import Clock from "../../../compoment/icon/Clock";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { getPortraitViewportContainer } from "../../../compoment/PortraitStage";

const MAX_TIME = 15 * 60;
const AUTO_HOME_MS = 10_000;

const GraffitiArtwork = () => {
  const navigate = useNavigate();
  const [selectedCanImage, setSelectedCanImage] = useState<string>("");
  const [timeLeft, setTimeLeft] = useState(MAX_TIME);

  useEffect(() => {
    const selectedCan = localStorage.getItem("selectedCan");
    if (!selectedCan) return;
    try {
      const parsed = JSON.parse(selectedCan);
      setSelectedCanImage(parsed.picture || "");
    } catch (err) {
      console.error("Invalid selectedCan in localStorage", err);
    }
  }, []);

  // Return to idle after brief instruction screen
  useEffect(() => {
    const t = setTimeout(() => {
      navigate("/", { replace: true });
    }, AUTO_HOME_MS);
    return () => clearTimeout(t);
  }, [navigate]);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <>
      {createPortal(
        <div className="fullScreenBg fullScreenBg--graffiti" />,
        getPortraitViewportContainer() ?? document.body
      )}
      <section className="artWorkGraffitiSection portraitDevice">
        <div className="artWorkGraffitiSection__inner">
          <div className="scanCard">
            <div className="timerSection">
              <span className="icon">
                <Clock />
              </span>
              You have{" "}
              <span className="timer">{formatTime(timeLeft)}</span> left to
              finish your art
            </div>

            {selectedCanImage ? (
              <div className="artWorkGraffitiSection__can">
                <img
                  src={selectedCanImage}
                  alt="selected can"
                  width={110}
                  style={{ rotate: "20deg" }}
                />
              </div>
            ) : null}

            <div className="heading">
              Pick up your can and start your <br/> graffiti artwork
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GraffitiArtwork;
